import React from "react";

const ShowSvgIcon = ({ size = 1, id, width, height, className }) => {
  const svgStyle = {
    transform: `scale(${size})`,
  };

  return (
    <svg
      style={svgStyle}
      className={className}
      width={width}
      height={height}
      role="img"
    >
      <use xlinkHref={`#${id}`}></use>
    </svg>
  );
};

export default ShowSvgIcon;
